import dayjs from 'dayjs'
import 'dayjs/locale/en'
import 'dayjs/locale/fr'
import 'dayjs/locale/ja'
import 'dayjs/locale/my'
import 'dayjs/locale/vi'
import localeData from 'dayjs/plugin/localeData'
import i18n from 'i18next'
import HttpBackend from 'i18next-http-backend'
import Cookies from 'js-cookie'
import { initReactI18next } from 'react-i18next'

dayjs.extend(localeData)

import {
  DEFAULT_LANGUAGE,
  SUPPORTED_LANGUAGES,
  LANGUAGE_STORAGE_KEY,
} from './constants'

// cookieから言語設定を取得
const getStoredLanguage = (): string => {
  try {
    return Cookies.get(LANGUAGE_STORAGE_KEY) || DEFAULT_LANGUAGE
  } catch {
    return DEFAULT_LANGUAGE
  }
}

i18n
  .use(HttpBackend) // 翻訳ファイルをhttp経由で非同期で取得できるようにするために追加
  .use(initReactI18next)
  .init({
    lng: getStoredLanguage(),
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: SUPPORTED_LANGUAGES,
    debug: process.env.NODE_ENV === 'development',

    ns: [
      'common',
      'validation',
      'page-assign',
      'page-assign-components',
      'page-assign-detail',
      'page-assign-history',
      'page-login',
      'page-notification',
      'page-notification-confirm',
      'page-notification-assign',
      'page-notification-suspension',
      'page-shift',
      'page-top',
      'page-setting',
      'page-insight-more-work',
      'page-insight-undesired-work',
      'page-insight-onboarding',
      'page-security-report',
      'page-notification-interviews',
    ],
    defaultNS: 'common',
    interpolation: {
      escapeValue: false, // React側がescapeするためfalse
    },

    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },

    react: {
      useSuspense: false,
    },
  })

// 初期言語に合わせてdayjsのロケールを設定
dayjs.locale(getStoredLanguage())

// 言語変更時にcookieに保存し、dayjsのロケールも同期（有効期限は1年）
i18n.on('languageChanged', (lng) => {
  try {
    Cookies.set(LANGUAGE_STORAGE_KEY, lng, { expires: 365 })
    dayjs.locale(lng)
  } catch (e) {
    console.error('Failed to save language preference:', e)
  }
})

export default i18n
